module.exports = __webpack_public_path__ + "static/media/chef-avatar-1@2x.ab21978b.png";